import { pdsTv } from '@nestle-npus-nbm/pds-ui';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { CMS_THEME } from '../../common/enums';
import ProductCardBody from './ProductCardBody';

interface Props {
  drupalId?: string;
  image: IGatsbyImageData;
  link: string;
  title: string;
  bvID: string;
  psID: string;
  cmsTheme?: CMS_THEME;
  brand?: string;
  type?: 'products' | 'offers';
  onClick?: () => void;
  outlinedCta?: boolean;
  linkDirect?: { title?: string; uri: string };
  productVariations?: {
    field_item_description: string;
    field_item_quantity: number;
    field_item_size: number;
    field_short_description: string;
    field_upc_code: string;
  }[];
  productStatuses?: IFieldProductStatus[];
}

const card = pdsTv({
  base: 'pds-flex pds-h-full pds-flex-col pds-border-none pds-bg-surface pds-text-surface-text',
  variants: {
    theme: {
      light: '',
      dark: 'pds-bg-surface-text pds-text-surface',
      neutral: 'pds-bg-transparent',
    },
  },
});

const ProductCard: React.FC<Props> = function ({
  title,
  link,
  image,
  bvID,
  psID,
  brand,
  drupalId,
  cmsTheme = CMS_THEME.LIGHT,
  type,
  onClick = () => {},
  outlinedCta = false,
  linkDirect = undefined,
  productVariations = [],
  productStatuses = [],
}: Props) {
  return (
    <div data-id={drupalId} className={card({ theme: cmsTheme })}>
      {/* Merges the link logic so that the linkDiret url will be used across the card. */}
      <ProductCardBody
        onClick={onClick}
        image={image}
        link={linkDirect?.uri ? linkDirect.uri : link}
        title={title}
        psID={psID}
        bvID={bvID}
        brand={brand}
        cardType={type}
        cmsTheme={cmsTheme}
        outlinedCta={outlinedCta}
        linkDirect={linkDirect}
        productVariations={productVariations}
        productStatuses={productStatuses}
      />
    </div>
  );
};
export default ProductCard;
